import React from 'react';
import BikeCard from 'components/BikeCard';
import { useSelector } from 'react-redux';
import { getBikeModel, getSubStep, getOfferBanner } from 'src/redux/app/selectors';
import FinanceOptionSummary from 'components/FinanceOptionSummary';
import YourDetailsSummary from 'components/YourDetailsSummary';
import YourDealer from 'components/YourDealer';
import YourDealerSummary from 'components/YourDealerSummary';
import OfferBanner from 'components/OfferBanner';

const StepThree = () => {
  const bikeModel = useSelector(getBikeModel);
  const subStep = useSelector(getSubStep);
  const offerBanner = useSelector(getOfferBanner);

  const dealerComponents = {
    a: YourDealer,
    b: YourDealerSummary,
  };

  const SubStepComponent = dealerComponents[subStep];

  return (
    <>
      <BikeCard bikeModel={bikeModel}></BikeCard>
      {offerBanner && <OfferBanner offerBanner={offerBanner}></OfferBanner>}
      <FinanceOptionSummary></FinanceOptionSummary>
      <YourDetailsSummary></YourDetailsSummary>
      <SubStepComponent></SubStepComponent>
    </>
  );
};

export default StepThree;
